export default "{\n    \"emptyPlaceholder\": \"Click to select a facility\",\n    \"searchPlaceholder\": \"Search by name or address\"\n}\n"